import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqKeys = [1, 2, 3, 4, 5, 6];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="relative bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[768px] px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("faq.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqKeys.map((num, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={num}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {t(`faq.q${num}`)}
                  </span>
                  <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center">
                    <i
                      className={`text-base transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {t(`faq.a${num}`)}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}